import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Me from "../assets/Images/profile-img.png";

const Box = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 65vw;
  display: flex;
  z-index: 1;

  background: linear-gradient(
        to right,
        ${(props) => props.theme.body} 50%,
        ${(props) => props.theme.text} 50%
      )
      bottom,
    linear-gradient(
        to right,
        ${(props) => props.theme.body} 50%,
        ${(props) => props.theme.text} 50%
      )
      top;
  background-repeat: no-repeat;
  background-size: 100% 2px;
  border-left: 2px solid ${(props) => props.theme.body};
  border-right: 2px solid ${(props) => props.theme.text};

  z-index: 1;

  @media (max-width: 120em) {
    width: 65vw;
  }
  @media (max-width: 50em) {
    flex-direction: column;
    justify-content: space-between;
    width: 50vw;
  }
  @media (max-width: 40em) {
    width: 60vw;
  }
  @media (max-width: 30em) {
    width: 70vw;
  }

  & > :first-child {
    border-top: 2px solid ${(props) => props.theme.body};
    border-bottom: 2px solid ${(props) => props.theme.body};

    @media (max-width: 50em) {
      border-bottom: 2px solid transparent;
      border-right: 2px solid ${(props) => props.theme.body};
    }
  }
  & > :last-child {
    border-top: 2px solid ${(props) => props.theme.text};
    border-bottom: 2px solid ${(props) => props.theme.text};

    @media (max-width: 50em) {
      border-left: 2px solid ${(props) => props.theme.text};
      border-right: 2px solid ${(props) => props.theme.text};
      border-top: 2px solid transparent;
    }
  }
`;

const SubBox = styled.div`
  position: relative;
  width: 50%;
  display: flex;

  @media (max-width: 50em) {
    width: 100%;
    height: 50%;
  }
  .pic {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: auto;

    @media (max-width: 50em) {
      width: 70%;
    }
    @media (max-width: 40em) {
      width: 80%;
    }
    @media (max-width: 30em) {
      width: 90%;
    }
  }
`;

const Text = styled.div`
  font-size: calc(1rem + 1.5vw);
  color: ${(props) => props.theme.body};
  padding: 2rem;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  & > *:last-child {
    color: ${(props) => `rgba(${props.theme.bodyRgba}, 0.6)`};
    font-size: calc(0.5rem + 1.5vw);
    font-weight: 300;
  }
  @media (max-width: 40em) {
    font-size: calc(1rem + 1.5vw);
    & > *:last-child {
      font-size: calc(0.5rem + 1vw);
    }
  }
`;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const Intro = ({ click }) => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowDimensions]);
  return (
    <Box
      initial={{
        height: 0,
      }}
      animate={{ height: `${windowDimensions.width <= 800 ? "70vh" : "55vh"}` }}
      transition={{ type: "spring", duration: 2, delay: 1 }}
    >
      <SubBox
        style={{
          backgroundColor: "black",
        }}
      >
        <Text>
          <h1>Hi,</h1>
          <h3>I'm Vinh Do.</h3>
          <h6>My computer screen is brighter than my future.</h6>
        </Text>
      </SubBox>
      <SubBox
        style={{
          backgroundColor: "white",
        }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2 }}
        >
          <img src={Me} className="pic" alt="Profile Pic" />
        </motion.div>
      </SubBox>
    </Box>
  );
};

export default Intro;
